export default __webpack_public_path__ + "static/media/move.64163ba1.png";